(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seed-calendar-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hv-seed-calendar')) return;
  class HVSeedCalendar extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const listen = (target, type, callback, capture = false) => target?.addEventListener(type, callback, {signal, capture});
      const players = [...this.querySelectorAll('[data-hv-player]')];
      for (const player of players) {
        const video = player.querySelector('video');
        const play = player.querySelector('[data-hv-play]');
        const error = player.parentElement.querySelector('[data-hv-media-error]');
        if (!video || !play) continue;
        play.hidden = false;
        const fail = () => {
          play.disabled = false;
          play.hidden = false;
          play.removeAttribute('aria-busy');
          if (error) error.hidden = false;
        };
        listen(play, 'click', async () => {
          if (error) error.hidden = true;
          play.disabled = true;
          play.setAttribute('aria-busy', 'true');
          try {
            if (video.error) video.load();
            await video.play();
          } catch (_) { fail(); }
          finally { play.disabled = false; play.removeAttribute('aria-busy'); }
        });
        listen(video, 'play', () => {
          document.querySelectorAll('hv-seed-calendar video').forEach(other => {
            if (other !== video && !other.paused) other.pause();
          });
          play.hidden = true;
          if (error) error.hidden = true;
        });
        listen(video, 'ended', () => { play.hidden = false; });
        listen(video, 'error', fail);
        listen(video, 'loadedmetadata', () => {
          if (Number.isFinite(video.duration)) {
            const duration = player.parentElement.querySelector('[data-hv-duration]');
            const seconds = Math.round(video.duration);
            if (duration) duration.textContent = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
          }
        });
      }
      listen(document, 'visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      });
      const selector = this.querySelector('[data-hv-variant]');
      const quantity = this.querySelector('[data-hv-quantity]');
      const submit = this.querySelector('[data-hv-submit]');
      const status = this.querySelector('[data-hv-stock]');
      const setVariant = () => {
        const option = selector?.options[selector.selectedIndex];
        if (!option || !submit) return;
        const available = option.dataset.available === 'true';
        this.querySelectorAll('[data-hv-price]').forEach(el => { el.textContent = option.dataset.price; });
        const compare = this.querySelector('[data-hv-compare]');
        if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
        submit.disabled = !available;
        submit.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        if (status) status.textContent = available ? '' : this.dataset.soldLabel;
        if (quantity) {
          const min = Number(option.dataset.min) || 1;
          const step = Number(option.dataset.step) || 1;
          const max = option.dataset.max ? Number(option.dataset.max) : null;
          quantity.min = String(min);
          quantity.step = String(step);
          if (max !== null) quantity.max = String(max); else quantity.removeAttribute('max');
          let next = Math.max(min, Number(quantity.value) || min);
          next = min + Math.ceil((next - min) / step) * step;
          if (max !== null && next > max) next = min + Math.floor((max - min) / step) * step;
          quantity.value = String(next);
        }
      };
      listen(selector, 'change', setVariant);
      setVariant();
      const nativeOptions = this.querySelector('[data-hv-native-options]');
      if (nativeOptions) {
        const nativeForm = [...document.querySelectorAll('form[action]')].find(form => {
          if (this.contains(form) || !form.querySelector('[name="id"]')) return false;
          try { return new URL(form.action || form.getAttribute('action'), document.baseURI).pathname.endsWith('/cart/add'); }
          catch (_) { return false; }
        });
        if (nativeForm) {
          nativeOptions.hidden = false;
          listen(nativeOptions, 'click', () => {
            nativeForm.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
            const focusTarget = nativeForm.querySelector('select, input:not([type="hidden"]), button[type="submit"]');
            focusTarget?.focus({preventScroll:true});
          });
        }
      }
      // Native Shopify form submission intentionally remains intact, including no-JS checkout.
      const sticky = this.querySelector('[data-hv-sticky]');
      const buy = this.querySelector('[data-hv-buy]');
      if (sticky && buy && 'IntersectionObserver' in window) {
        this.classList.add('hvsc-has-sticky');
        this.observer = new IntersectionObserver(entries => {
          sticky.hidden = entries[0].isIntersecting;
        }, {threshold:0});
        this.observer.observe(buy);
      }
      // Make in-section links focus their destinations without relying on theme scripts.
      listen(this, 'click', event => {
        const link = event.target.closest('a[data-hv-scroll]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const id = link.getAttribute('href')?.slice(1);
        const target = id && document.getElementById(id);
        if (!target || !this.contains(target)) return;
        event.preventDefault();
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
        target.focus({preventScroll:true});
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  }
  customElements.define('hv-seed-calendar', HVSeedCalendar);
})();


  } catch(e) { console.error(e); }
})();
})();
